export const PrinterErrorsHistoryTableHeader = [
  { text: "Mesa", value: "data.id", align: "start", sortable: true },
  { text: "Hora", value: "data.time", align: "start", sortable: true },
  {
    text: "Impresora",
    value: "printerName",
    align: "start",
    sortable: true
  },
  {
    text: "Url",
    value: "printerUrl",
    align: "start",
    sortable: false
  },
  { text: "Data", value: "data", align: "start", sortable: false },
  { text: "Referer", value: "referer", align: "start", sortable: false },
  { text: "User Agent", value: "userAgent", align: "start", sortable: false }
];

export const PrinterHistoryTableHeader = [
  { text: "Mesa", value: "data.id", align: "start", sortable: true },
  { text: "Hora", value: "data.time", align: "start", sortable: true },
  {
    text: "Impresora",
    value: "printerName",
    align: "start",
    sortable: true
  },
  {
    text: "Url",
    value: "printerUrl",
    align: "start",
    sortable: false
  },
  { text: "Data", value: "data", align: "start", sortable: false },
  { text: "Referer", value: "referer", align: "start", sortable: false },
  { text: "User Agent", value: "userAgent", align: "start", sortable: false }
];

export const LogsHistoryTableHeader = [
  { text: "Hora", value: "time", align: "start", sortable: true },
  {
    text: "Tipo",
    value: "level",
    align: "start",
    sortable: true
  },
  {
    text: "Contexto",
    value: "context",
    align: "start",
    sortable: false
  },
  { text: "Component", value: "component", align: "start", sortable: false },
  {
    text: "Mensaje",
    value: "message",
    align: "start",
    sortable: false
  },
  { text: "Data", value: "data", align: "start", sortable: false },
  { text: "Referer", value: "referer", align: "start", sortable: false },
  { text: "User Agent", value: "userAgent", align: "start", sortable: false }
];

export const PrintersTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  {
    text: "Activa",
    value: "active",
    align: "start",
    sortable: true
  },
  {
    text: "Url",
    value: "url",
    align: "start",
    sortable: false
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const CashDrawerTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  {
    text: "Activo",
    value: "active",
    align: "start",
    sortable: true
  },
  {
    text: "Url",
    value: "url",
    align: "start",
    sortable: false
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const UsersTableHeader = [
  { text: "Id", value: "id", align: "start", sortable: true },
  {
    text: "Nombre",
    value: "name",
    align: "start",
    sortable: true
  },
  {
    text: "Email",
    value: "email",
    align: "start",
    sortable: false
  },
  {
    text: "Roles",
    value: "roles",
    align: "start",
    sortable: false
  },
  {
    text: "Disable/Enable",
    value: "enabled",
    align: "start",
    sortable: false
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const ZonaTablesQRTableHeader = [
  { text: "Zona", value: "name", align: "start", sortable: true },
  {
    text: "Nombre",
    value: "name",
    align: "start",
    sortable: true
  },
  {
    text: "Cartas",
    value: "selectedMenu",
    align: "start",
    sortable: true
  },
  {
    text: "Activa",
    value: "active",
    align: "start",
    sortable: false
  },
  {
    text: "Acepta pago directo",
    value: "acceptDirectPayment",
    align: "start",
    sortable: false
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const TablesQRTableHeader = [
  { text: "Mesa QR", value: "table", align: "start", sortable: true },
  {
    text: "Zona",
    value: "zone_id",
    align: "start",
    sortable: true
  },
  {
    text: "Activo",
    value: "active",
    align: "start",
    sortable: false
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const PrintingRouteTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  {
    text: "Grupo de pedidos",
    value: "group_order_id",
    align: "start",
    sortable: true
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const GroupOrderTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  {
    text: "Activo",
    value: "active",
    align: "start",
    sortable: true
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const MenuGroupTableHeader = [
  { text: "Imagen", value: "menu_image", align: "start", sortable: false },
  { text: "Nombre", value: "name", align: "start", sortable: true },
  { text: "Descripción", value: "description", align: "start", sortable: true },
  { text: "Price", value: "price", align: "start", sortable: true },
  { text: "Incluye Bebida", value: "isDrink", align: "start", sortable: true },
  {
    text: "Incluye Postres",
    value: "isDessert",
    align: "start",
    sortable: true
  },
  {
    text: "Es de plato unico",
    value: "isStarter",
    align: "start",
    sortable: true
  },
  {
    text: "Activo",
    value: "active",
    align: "start",
    sortable: true
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

// MenuGroupDialog data-table headers
export const MenuGroupDialogHeader = [
  {
    text: "Nombre",
    value: "name",
    align: "start",
    sortable: true,
    class: "header-name"
  },
  {
    text: "Categoría",
    value: "category_id",
    align: "start",
    sortable: false
  },
  {
    text: "Selección",
    value: "active",
    align: "center",
    sortable: false,
    class: "selection-text"
  },
  {
    text: "Cargo Adicional",
    value: "additional_charge",
    align: "start",
    sortable: false,
    class: "additional-text"
  }
];

export const MenusOrderTableHeader = [
  { text: "Imagen", value: "menu_image", align: "start", sortable: false },
  { text: "Nombre", value: "name", align: "start", sortable: true },
  { text: "Tipo", value: "type", align: "start", sortable: true },
  { text: "Orden", value: "sort", align: "start", sortable: true },
  {
    text: "Guardar",
    value: "editAction",
    align: "start",
    sortable: false
  }
];

export const MenusTableHeader = [
  { text: "Imagen", value: "menu_image", align: "start", sortable: false },
  { text: "Nombre", value: "name", align: "start", sortable: true },
  {
    text: "Activo",
    value: "active",
    align: "start",
    sortable: true
  },
  {
    text: "Editar",
    value: "editAction",
    align: "start",
    sortable: false
  },
  { text: "Eliminar", value: "deleteAction", sortable: false }
];

export const MenuDialogHeader = [
  {
    text: "Nombre",
    value: "name",
    align: "start",
    sortable: true,
    class: "header-name"
  },
  {
    text: "Categoría",
    value: "category_id",
    align: "start",
    sortable: false
  },
  {
    text: "Selección",
    value: "active",
    align: "center",
    sortable: false,
    class: "header-switch"
  }
];

export const SubCategoriesTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  { text: "Categoría", value: "category_id", sortable: true },
  { text: "Orden", value: "sort", sortable: true },
  { text: "Editar", value: "editAction", sortable: false },
  { text: "Eliminar", value: "deleteAction", sortable: false }
];

export const CategoriesTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  { text: "SubCategorías", value: "id", sortable: true },
  { text: "Grupo de Pedidos", value: "group_order_id", sortable: true },
  { text: "Rutas de impresión", value: "type_order_id", sortable: true },
  { text: "Tipo de producto", value: "product_type_id", sortable: true },
  { text: "Orden", value: "sort", sortable: true },
  { text: "Editar", value: "editAction", sortable: false },
  { text: "Eliminar", value: "deleteAction", sortable: false }
];

export const ProductsTableHeader = [
  { text: "Nombre", value: "name", align: "start", sortable: true },
  { text: "Descripción", value: "description", sortable: true },
  { text: "Stock", value: "stock", sortable: true },
  { text: "Categoría", value: "category_id", sortable: true },
  { text: "Subcategoría", value: "sub_category_id", sortable: true },
  { text: "Precios", value: "price", sortable: true },
  { text: "Orden", value: "sort", sortable: true },
  { text: "Actualizado en", value: "updated_on", sortable: true },
  { text: "Editar", value: "editAction", sortable: false },
  { text: "Eliminar", value: "deleteAction", sortable: false }
];

export const PaymentsHistoryTableHeader = [
  { text: "Número", value: "number", align: "start", sortable: true },
  { text: "ID de pago externo", value: "externalPaymentId", sortable: true },
  { text: "Fecha de pago", value: "payment_on", sortable: true },
  { text: "Mesa", value: "tableQR", sortable: true },
  { text: "Metódo de pago", value: "payment_method", sortable: true },
  { text: "Factura/Ticket", value: "invoiceRequest", sortable: true },
  { text: "Ticket enviado", value: "receipt_is_sent", sortable: true },
  { text: "Total", value: "amount_paid_by_user", sortable: true },
  // { text: "Cantidad devuelta", value: "amount_refunded", sortable: true },
  // { text: "Total", value: "total", sortable: true },
  { text: "Visualizar", value: "editAction", sortable: false }
];

export const OrdersHistoryTableHeader = [
  { text: "Hora", value: "time", align: "start", sortable: true },
  { text: "Pedido", value: "name", sortable: true },
  { text: "Tipo De Producto", value: "orderType", sortable: true },
  { text: "Email", value: "email", sortable: true },
  { text: "Estado", value: "isPending", sortable: true },
  { text: "Cantidad", value: "quantity", sortable: true },
  { text: "Mesa", value: "tableQR", sortable: true },
  { text: "Precio", value: "price", sortable: true },
  { text: "Total", value: "totalPrice", sortable: true }
];

export const ZboxClosuresTableHeader = [
  { text: "Número", value: "id", align: "start", sortable: true },
  { text: "Apertura", value: "opened_on", sortable: true },
  { text: "Cierre", value: "closed_on", sortable: true },
  {
    text: "Tarjeta",
    value: "total_invoiced_on_credit_card",
    sortable: true
  },
  { text: "Efectivo", value: "total_invoiced_in_cash", sortable: true },
  { text: "Datáfono", value: "total_invoiced_in_datafono", sortable: true },
  {
    text: "Google Pay",
    value: "total_invoiced_in_google_pay",
    sortable: true
  },
  {
    text: "Apple Pay",
    value: "total_invoiced_in_apple_pay",
    sortable: true
  },
  { text: "Bizum", value: "total_invoiced_in_bizum", sortable: true },
  { text: "Total", value: "totalPrice", sortable: true },
  { text: "Visualizar", value: "editAction", sortable: false }
];
